import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app-routes';
import { provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideTohumUiConfig } from '@anadolu-commons/tohum-ui';
import { menuConfig } from './app.menu';
import { TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { provideTransloco } from '@ngneat/transloco';
import { APP_INITIALIZER, Injector } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
//import { AuthInterceptor } from './auth/auth.interceptor';
import { TohumUiInitService } from '@anadolu-commons/tohum-ui';

const initApp = (initService: TohumUiInitService) => () => initService.init();
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(),
    importProvidersFrom(),
    provideTohumUiConfig({
      menuConfig,
      i18nConfig: {
        langs: ['tr', 'en'],
        defaultLang: 'tr',
      },
    }),
    provideTransloco({
      config: {
        availableLangs: ['tr', 'en'],
        defaultLang: 'tr',
        reRenderOnLangChange: true,
        prodMode: false,
      }
    }),
    {
      provide: TINYMCE_SCRIPT_SRC,
      useValue: 'assets/tinymce/tinymce.min.js?v=5.10.9',
    },
   
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [TohumUiInitService],
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthInterceptor,
    //   multi: true,
    // },
    DeviceDetectorService,
  ],
};
